import React from 'react';
import { Tab } from '@mui/material';
import { RecordTabs } from 'components/record-shell/RecordShell';

interface PatientTabProps {
  tab: string;
  onChange: (newTab: string) => void;
  // paciente já cadastrado: a ficha é a primeira aba
  showRecord?: boolean;
}

const PatientTab: React.FC<PatientTabProps> = ({ tab, onChange, showRecord }) => {
  return (
    <RecordTabs tab={tab} onChange={onChange}>
      {showRecord && <Tab value="record" label="Ficha" />}
      <Tab value="main" label="Dados pessoais" />
      <Tab value="contact" label="Contato" />
      <Tab value="address" label="Endereço" />
      <Tab value="observation" label="Observações" />
    </RecordTabs>
  );
};

export default PatientTab;
